<button class="saving-feedback-button" [ngClass]="[ButtonColor, CustomClass]" [disabled]="IsButtonDisabled" [title]="HoverText">
	<span *ngIf="Icon" class="button-icon material-symbols-outlined">{{Icon}}</span>
	<span>{{ IsActionBeingPerformed ? ActiveActionDescriptor : InactiveActionDescriptor }}</span>
	<div *ngIf="IsActionBeingPerformed" class="loading-spinner"></div>
</button>